import { Component } from '@angular/core';
import { TechnicalFormComponent } from 'src/app/+grid-application-shared/components/technical-form/technical-form.component';
import { GridCompatibilityProcessStatus } from '../entities/enums/gridCompatibilityProcessStatus';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from 'src/app/services/common.service';
import { EnvironmentService } from 'src/app/services/environment.service';
import { ErrorService } from 'src/app/services/error/error.service';
import { FileService } from 'src/app/services/file.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { NetzTranslateService } from 'src/app/services/netz-translate.service';
import { GridCompatibilityOrderProcessService } from '../services/grid-compatibility-order-process.service';
import { GridCompFeedInApplication } from '../entities/gridCompFeedInApplication';
import { GridCompatibilityService } from '../services/grid-compatibility.service';
import { GridCompatibilityCommentsService } from '../services/grid-compatibility-comments.service';
import { NavigationStateShareService } from 'src/app/services/navigation-state-share.service';

@Component({
  selector: 'app-grid-comp-technical-form',
  templateUrl: './grid-comp-technical-form.component.html',
  styleUrls: ['./grid-comp-technical-form.component.scss'],
})
export class GridCompTechnicalFormComponent extends TechnicalFormComponent<GridCompFeedInApplication> {
  private storageWarning: boolean = false;
  private photovoltaicWarning: boolean = false;
  private generatorWarning: boolean = false;

  constructor(
    fileService: FileService,
    translate: NetzTranslateService,
    commonService: CommonService,
    service: GridCompatibilityService,
    commentService: GridCompatibilityCommentsService,
    errorService: ErrorService,
    router: Router,
    route: ActivatedRoute,
    localStorageService: LocalStorageService,
    environmentService: EnvironmentService,
    translateService: TranslateService,
    private orderProcessService: GridCompatibilityOrderProcessService,
    private navigationStateShareService: NavigationStateShareService
  ) {
    super(
      fileService,
      translate,
      commonService,
      service,
      commentService,
      errorService,
      router,
      route,
      localStorageService,
      environmentService,
      translateService
    );
  }

  protected loadOrderProcess(): void {
    this.preventLeak(this.orderProcessService.orderProcess$).subscribe(orderProcess =>
      this.setEditabilityBasedOnProcessStatus(orderProcess.status)
    );

    this.orderProcessService.loadOrderProcess(this.applicationId);
  }

  protected proceed(): void {
    const url = this.isDetailsView
      ? `/${this.route.snapshot.data.module}/personal-data/${this.applicationId}`
      : `/${this.route.snapshot.data.module}/personal-data`;
    this.preventCanDeactivateCheck = true;
    this.router.navigate([url]);
    if (!this.isDetailsView) {
      this.navigationStateShareService.setFormState(this.step);
    }
  }

  private setEditabilityBasedOnProcessStatus(gridCompProcessStatus: GridCompatibilityProcessStatus): void {
    const externalRoleEditableStatuses = [GridCompatibilityProcessStatus.OpenIssue];
    const internalRoleEditableStatuses = [GridCompatibilityProcessStatus.RequestUpdated, GridCompatibilityProcessStatus.RequestSent];

    this.editabilityBasedOnProcessStatus.technicianRole = externalRoleEditableStatuses.includes(gridCompProcessStatus);
    this.editabilityBasedOnProcessStatus.customerRole = externalRoleEditableStatuses.includes(gridCompProcessStatus);
    this.editabilityBasedOnProcessStatus.internalRoles = internalRoleEditableStatuses.includes(gridCompProcessStatus);
  }

  public storageWarningsVisible($event: boolean) {
    this.storageWarning = $event;
  }

  public photovoltaicWarningsVisible($event: boolean) {
    this.photovoltaicWarning = $event;
  }

  public generatorWarningsVisible($event: boolean) {
    this.generatorWarning = $event;
  }

  public warningsVisible(): boolean {
    return this.storageWarning || this.photovoltaicWarning || this.generatorWarning;
  }
}
